// ナレッジに関する定数定義

/**
 * ドキュメントタイプごとの有効化可能な最大ナレッジ数
 */
export const MAX_ACTIVE_KNOWLEDGE_PER_TYPE = 10;

/**
 * ナレッジのプロンプト（meta_prompt）の最大文字数
 */
export const MAX_PROMPT_LENGTH = 500;
